<template>
    <BaseDialog
        :showDialog="showProFormaDialog"
        maxDialogWidth="600"
        headline="lang_ERP_SHIPPING_ACTION_CREATE_PRO_FORMA"
        :close="closeDialog"
        maxCardHeight="1110"
        :scrollable="false"
        :alvqa="alvqa"
    >

        <template v-slot:dialogText>
            <v-container fluid> 
                <v-row>
                    <v-col class="pl-0">
                        <BaseEditPageTextField 
                            :context="context"
                            field="AmountToSplit"
                            :label="$t('lang_GENERIC_CAPTION_AMOUNT')"
                            :alvqa="alvqa + '-textfield-amount-to-split'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pl-0">
                        <BaseEditPageTextarea 
                            :context="context"
                            field="ProFormaText"
                            rows="3"
                            :label="$t('lang_ERP_SHIPPING_CAPTION_PRO_FORMA_TEXT')"
                            :alvqa="alvqa + '-textfield-pro-forma-text'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
        <v-container>
            <v-row>
                <v-spacer></v-spacer>
                <v-col class="d-flex justify-end pl-0 pt-0" align-self="center">
                    <BaseButton
                        label="lang_GENERAL_CAPTION_ICON_DOWNLOAD"
                        @click="getProForma()"
                        :alvqa="alvqa"
                    /> 
                </v-col>
            </v-row>
        </v-container>
    
    </template>

    </BaseDialog>
  
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'

export default {
    name:'ProFormaDialog',

    components: {
        BaseDialog,
        BaseEditPageTextField,
        BaseButton,
        BaseEditPageTextarea,
    },
    data() {
        return {
            alvqa: 'erp-shipping-pro-forma-dialog',
            context: 'ProFormaDialog'
        }
    },
    computed: {
        showProFormaDialog: {
            get() { return this.$store.getters.getShowProFormaDialog },
            set(show) { this.$store.commit('setShowProFormaDialog', show) }
        },
        setAmountToSplit: {
            get() { return this.$store.getters.getProFormaDialogDetailsAmountToSplit },
            set(value) { this.$store.commit('setProFormaDialogDetailsAmountToSplit', value) }
        },
        setProFormaText: {
            get() { return this.$store.getters.getProFormaDialogDetailsProFormaText },
            set(value) { this.$store.commit('setProFormaDialogDetailsProFormaText', value) }
        },
    },
    methods: {
        closeDialog() {
            this.showProFormaDialog = false
            this.setAmountToSplit = ''
            this.setProFormaText = ''
        },
        getProForma(){
            this.$store.dispatch("createProForma")
        }
    }
}
</script>

<style>

</style>